import api from './api';

// Service pour gérer les opérations liées aux hôtels
const hotelService = {
  // Récupérer tous les hôtels (avec pagination)
  getAllHotels: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/hotels?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Récupérer un hôtel par son ID
  getHotelById: async (id) => {
    try {
      const response = await api.get(`/hotels/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Recherche d'hôtels avec filtres
  searchHotels: async (criteria = {}, page = 1, limit = 10) => {
    try {
      // Construction des paramètres de requête
      let queryParams = `page=${page}&limit=${limit}`;
      
      if (criteria.ville) queryParams += `&ville=${criteria.ville}`;
      if (criteria.dateArrivee) queryParams += `&dateArrivee=${criteria.dateArrivee}`;
      if (criteria.dateDepart) queryParams += `&dateDepart=${criteria.dateDepart}`;
      if (criteria.nombrePersonnes) queryParams += `&nombrePersonnes=${criteria.nombrePersonnes}`;
      if (criteria.minPrice) queryParams += `&minPrice=${criteria.minPrice}`;
      if (criteria.maxPrice) queryParams += `&maxPrice=${criteria.maxPrice}`;
      if (criteria.etoiles) queryParams += `&etoiles=${criteria.etoiles}`;
      if (criteria.equipements) {
        criteria.equipements.forEach(eq => {
          queryParams += `&equipements=${eq}`;
        });
      }
      if (criteria.sortBy) queryParams += `&sortBy=${criteria.sortBy}`;
      
      const response = await api.get(`/hotels/search?${queryParams}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Vérifier la disponibilité d'un hôtel pour des dates spécifiques
  checkAvailability: async (hotelId, dateArrivee, dateDepart, nombrePersonnes) => {
    try {
      const response = await api.get(`/hotels/${hotelId}/availability`, {
        params: { dateArrivee, dateDepart, nombrePersonnes }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Créer un nouveau hôtel (admin)
  createHotel: async (hotelData) => {
    try {
      const formData = new FormData();
      
      // Ajouter les champs texte
      Object.keys(hotelData).forEach(key => {
        if (key !== 'images' && key !== 'equipements') {
          formData.append(key, hotelData[key]);
        }
      });
      
      // Ajouter les images
      if (hotelData.images && Array.isArray(hotelData.images)) {
        hotelData.images.forEach((img, index) => {
          if (img instanceof File) {
            formData.append(`images`, img);
          }
        });
      }
      
      // Ajouter les équipements
      if (hotelData.equipements && Array.isArray(hotelData.equipements)) {
        formData.append('equipements', JSON.stringify(hotelData.equipements));
      }

      const response = await api.post('/hotels', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Mettre à jour un hôtel (admin)
  updateHotel: async (id, hotelData) => {
    try {
      const formData = new FormData();
      
      // Même logique que pour createHotel
      Object.keys(hotelData).forEach(key => {
        if (key !== 'images' && key !== 'equipements') {
          formData.append(key, hotelData[key]);
        }
      });
      
      if (hotelData.images && Array.isArray(hotelData.images)) {
        hotelData.images.forEach((img, index) => {
          if (img instanceof File) {
            formData.append(`images`, img);
          }
        });
      }
      
      if (hotelData.equipements && Array.isArray(hotelData.equipements)) {
        formData.append('equipements', JSON.stringify(hotelData.equipements));
      }

      const response = await api.put(`/hotels/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Supprimer un hôtel (admin)
  deleteHotel: async (id) => {
    try {
      const response = await api.delete(`/hotels/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Calculer le prix en fonction du nombre d'adultes et d'enfants
  calculatePriceWithGuests: async (hotelId, nombreAdultes, nombreEnfants, nbNuits, isConnected = false, userEmail = null) => {
    try {
      const response = await api.post('/hotels/calculate-price-with-guests', {
        hotelId,
        nombreAdultes,
        nombreEnfants,
        nbNuits,
        isConnected,
        userEmail
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default hotelService;